
export class ErroDeTraducao extends Error {
  constructor(mensagem: string) {
    super(mensagem)
    this.name = 'ErroDeTraducao'
  }
}
